// import WavesurferPlayer from '@wavesurfer/react'
import { useState, useMemo, useEffect, useRef } from 'react'
import Timeline from 'wavesurfer.js/dist/plugins/timeline.esm.js'
// import Regions from 'wavesurfer.js/dist/plugins/regions.esm.js'
// import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions';
// import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline';
// //import MarkersPlugin from "wavesurfer.js/src/plugin/markers";
import Player from './Player';
import { use } from 'react';
import { set } from 'rsuite/esm/internals/utils/date';

export default function Comparator(props){

//console.log("Comparator render, tracks:", props.tracks.length)

const [wavesurfer, setWavesurfer] = useState(null)
const [isPlaying, setIsPlaying] = useState(false)
const [stopCount, setStopCount] = useState(0)
const [replayCount, setReplayCount] = useState(0)
const [showingAll, setShowingAll] = useState(true)
const [selected, setSelected] = useState(0)
const [currentTime, setCurrentTime] = useState(0)
const playerRefs = useRef({})

const onReady = (ws) => {
    setWavesurfer(ws)
    setIsPlaying(false)
}

const onPlayPause = () => {
    wavesurfer && wavesurfer.playPause()
}

const plugins = useMemo(() => 
    [Timeline.create()], []
)

useEffect(() => {
    setSelected(props.tracks.length-1)
}, [props.tracks.length])

//console.log("Comparator render, tracks:", props.tracks)
const tracks = [];
for(let i=props.tracks.length-1; i>=0; i--){
    console.log(props.tracks[i])
    //console.log(selected)
        tracks.push(
            <div key={i} className={selected==i? " surferRow" : "notActiveTrack surferRow"}>
                <button onClick={()=>{setSelected(i)}}><span className={selected==i? "activeButton" : "notActiveButton"}>{i+1}</span></button>
                <Player
                    ref={(el) => { playerRefs.current[i] = el }}
                    track= {props.tracks[i]}
                    isPlaying={isPlaying}
                    stopCount={stopCount}
                    replayCount={replayCount}
                    trackNum={i}
                    selected={selected}
                    syncTime={currentTime}
                />
                {/* <div key={props.tracks[i].key}>
                    Uploaded on {new Date(props.tracks[i].upload_date).toLocaleDateString()}
                </div> */}
            </div>
        )
}

    return(
        <div id="comparatorControls">
            {props.tracks.length > 0 && (
            <div id="comparatorPlayControls" className='flex flex-row justify-start'>
                <button title={isPlaying ? "Pause" : "Play"} onClick={()=>{setIsPlaying(!isPlaying)}}>
                    {isPlaying ? <i class="material-icons">pause</i> : <i class="material-icons">play_arrow</i>}
                </button>
                <button title="Stop" onClick={()=>{ setIsPlaying(false); setStopCount(c=>c+1) }}><i class="material-icons">stop</i></button>
                <button title="Restart" onClick={()=>{ setIsPlaying(true); setReplayCount(c=>c+1) }}><i class="material-icons">replay</i></button>
                {props.tracks.length > 1 && (
                <button title={showingAll ? "Hide" : "Show"} onClick={()=>{setShowingAll(!showingAll)}} id="showAllButton">
                    {showingAll ? <i class="material-icons">visibility_off</i> : <i class="material-icons">visibility</i>}
                </button>
                )}
                <button title="Sync" onClick={()=>{
                    const time = playerRefs.current[selected]?.getCurrentTime();
                    if (time != null) setCurrentTime(time);
                }}>
                    <i class="material-icons">schedule</i>
                </button>
            </div>
            )}
            <div id="allTracks">
                
                <div className={showingAll ? "allTracks" : "oneTrack"}>
                {tracks}
                </div>
                {/* {currentTime} */}
            </div>
        </div>
    )
}